import type { ReactNode } from 'react';
import styles from './onboarding.module.css';

/** Step Heading 1; receives focus on every step change (spec §2.2). */
export function StepHeading({
  title,
  lead,
  center = false,
}: {
  title: string;
  lead: ReactNode;
  center?: boolean;
}) {
  return (
    <div className={[styles.heading, center ? styles.center : ''].join(' ')}>
      <h1 id="step-heading" tabIndex={-1}>
        {title}
      </h1>
      <p className={styles.lead}>{lead}</p>
    </div>
  );
}
